module.exports = __webpack_public_path__ + "img/video-5.52e83617.jpg";